/**
 * The longest wait a platform timer performs as asked. Above it the timer fires
 * at once, so a longer wait would become the immediate one it was meant to
 * prevent. A retry delay, a backoff value, a throttle window and a deadline
 * above it are refused with a `RangeError` instead.
 *
 * Internal to this package, so not exported from `index.ts`.
 */
export const MAX_TIMER_MS = 2_147_483_647;
